import { render, staticRenderFns } from "./NotificationsNav.vue?vue&type=template&id=74ee5c90&"
import script from "./NotificationsNav.vue?vue&type=script&lang=js&"
export * from "./NotificationsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports